import React, { useContext, useEffect, useState } from 'react';
import { fetchTasksForGroup } from '../../../Service/restapi/taskService';
import { TaskField } from './TaskField';

export const TaskGroup = ({ group, entityId, lastModified }) => {
  const [tasks, setTasks] = useState();

  const { id, name } = group;

  useEffect(() => {
    loadTasks();
  }, [lastModified, group]);

  if (!tasks || tasks.length === 0) {
    return null;
  }

  const styles = {
    container: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      marginTop: 5,
      marginBottom: 15,
      padding: 8,
      backgroundColor: 'rgb(251, 251, 251)',
      border: '1px solid rgba(0, 0, 0, .125)',
      borderRadius: 4,
    },
    group: {
      border: '1px solid rgba(0, 0, 0, .125)',
      borderRadius: 4,
      padding: 5,
      marginTop: 15,
      maxWidth: 200,
    },
    groupName: {
      marginTop: -14,
      backgroundColor: '#ffffff',
      paddingLeft: 5,
      paddingRight: 5,
      border: '1px solid rgba(0, 0, 0, .125)',
      borderRadius: 4,
      fontSize: 11,
      width: 'fit-content',
    },
    groupFields: {
      margin: 5,
    },
  };

  function loadTasks() {
    fetchTasksForGroup(id, entityId)
      .then((resp) => {
        if (resp.ok) {
          resp.json().then((tasks) => {
            setTasks(tasks);
          });
        } else {
          console.error(`could not load tasks of list ${name}`);
        }
      })
      .catch(() => {
        console.error(`could not load tasks of list ${name}`);
      });
  }

  return (
    <div style={styles.container}>
      <div style={styles.groupName}>{name}</div>
      <div style={styles.groupFields}>
        {tasks.map((task, index) => (
          <TaskField key={index} task={task} entityId={entityId} />
        ))}
      </div>
    </div>
  );
};
